import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import MatTableHead from './MatTableHead';
import MatTableToolbar from './MatTableToolbar';
import { hasAccess } from "../../../Services/SecurityService";
import { util } from "../../../../../src/shared/util";
import { FullWideNotification } from '../../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

function getSorting(order, orderBy) {
  if (order === 'desc') {
    return (a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return -1;
      }
      if (a[orderBy] > b[orderBy]) {
        return 1;
      }
      return 0;
    };
  }
  return (a, b) => {
    if (a[orderBy] > b[orderBy]) {
      return -1;
    }
    if (a[orderBy] < b[orderBy]) {
      return 1;
    }
    return 0;
  };
}

class MatTable extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  state = {
    order: 'asc',
    orderBy: 'tag',
    selected: new Map([]),
    data: this.props.list,
    page: 0,
    rowsPerPage: 10,
  };

  getStatusName(value) {
    let status = [
      {value:"ATIVO", label: this.props.t('forms.ativo')},
      {value:"INATIVO", label: this.props.t('forms.inativo')}
    ];
    let total = status.length;
    for(let i = 0; i < total; i++){
      if(status[i].value === value){
        return status[i].label;
      }
    }
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    const { orderBy: stateOrderBy, order: stateOrder } = this.state;

    if (stateOrderBy === property && stateOrder === 'desc') { order = 'asc'; }

    this.setState({ order, orderBy });
  };

  handleTextSort = (event) => {
    let textFilter = event.target.value.toLowerCase();

    const { data } = this.state;
    let copyData = [...data];

    if(textFilter !== undefined && textFilter !== ''){
      copyData = this.props.list.filter(obj => 
        obj.name.toLowerCase().includes(textFilter)
      );
    }else{
      copyData = this.props.list;
    }
    
    this.setState({ data: copyData});
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      const { data } = this.state;
      const newSelected = new Map();
      data.map(n => newSelected.set(n.id, true));
      this.setState({ selected: newSelected });
      return;
    }
    this.setState({ selected: new Map([]) });
  };

  handleClick = (event, obj) => {
    const { selected } = this.state;
    const newSelected = new Map(selected);
    newSelected.set(obj.id);
    this.setState({ selected: newSelected });
    this.props.setSelected(obj);
  };

  handleClickCheckBox = (event, obj) => {
    const { selected } = this.state;
    const newSelected = new Map(selected);
    const value = newSelected.get(obj.id);
    let isActive = true;
    if (value) {
      isActive = false;
    }
    newSelected.set(obj.id, isActive);
    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleDeleteSelected = () => {
    const { data } = this.state;
    let copyData = [...data];
    const { selected } = this.state;

    let id = 0;

    let mapKeys = selected.keys();
    while(id = mapKeys.next().value){
      // copyData = copyData.filter(obj => obj.id !== id);
      // deleteRequerimento(id)
      // .then(data => {
      //   if(data === undefined || (data !== undefined && data.error === undefined)){
      //     if(data.erros.length === 0){
      //       this.props.updateTable({}, this.props.t('forms.dataDeleteSuccess'));
      //     }else{
      //       if(data.erros !== undefined && data.erros !== undefined && data.erros.length > 0){
      //         for(let i = 0; i < data.erros.length; i++){
      //           this.props.updateTable({}, this.props.t('erros.'+data.erros[i]), false);
      //         }
      //       }
      //     }
      //   } else {
      //     this.props.updateTable({}, this.props.t('forms.dataDeleteError'), false);
      //   }
      // });
    }
    this.setState({ data: copyData, selected: new Map([]) });
  };

  isSelected = (id) => {
    const { selected } = this.state;
    return !!selected.get(id);
  };

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.list !== this.props.list){
      this.setState({ data: this.props.list});
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  getCheck(notOK, isSelected, d){
    if(!notOK){
      return <TableCell className="material-table__cell" padding="checkbox">
              <Checkbox 
                checked={isSelected} 
                onClick={event => this.handleClickCheckBox(event, d)}
                className="material-table__checkbox" />
            </TableCell>
    }
    return "";
  }

  render() {
    const {
      data, order, orderBy, selected, rowsPerPage, page,
    } = this.state;
    const emptyRows = 0;//rowsPerPage - Math.min(rowsPerPage, data.length - (page * rowsPerPage));
    
    let notOK = !hasAccess("MENU_REQUIREMENT_DELETE");

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{this.props.title}</h3>
            </div>
            <MatTableToolbar
              numSelected={[...selected].filter(el => el[1]).length}
              handleDeleteSelected={this.handleDeleteSelected}
              onRequestSort={this.handleRequestSort}
              onTextSort={this.handleTextSort}
            />
            <div className="material-table__wrap">
              <Table className="material-table">
                <MatTableHead
                  numSelected={[...selected].filter(el => el[1]).length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={this.handleSelectAllClick}
                  onRequestSort={this.handleRequestSort}
                  rowCount={data.length}
                  notOK={notOK}
                />
                <style>
                  {`
                    .MuiTableCell-root {
                      padding: 5px !important;
                    }
                  `}
                </style>
                <TableBody>
                  {data
                    .sort(getSorting(order, orderBy))
                    .slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage)
                    .map((d) => {
                      const isSelected = this.isSelected(d.id);
                      return (
                        <TableRow
                        className={(d.id === null ? 'material-table__row_alert' : 'material-table__row') }
                          role="checkbox"
                          aria-checked={isSelected}
                          tabIndex={-1}
                          key={d.id}
                          selected={isSelected}
                        >
                          {this.getCheck(notOK, isSelected, d)}
                          <TableCell
                            className="material-table__cell material-table__cell-right"
                            component="th"
                            onClick={event => this.handleClick(event, d)}
                            scope="row"
                            padding="none"
                          >
                            {this.getStatusName(d.status)}
                          </TableCell>
                          <TableCell
                            className="material-table__cell material-table__cell-right"
                            onClick={event => this.handleClick(event, d)}
                          >
                            {d.name}
                          </TableCell>
                          <TableCell
                            className="material-table__cell material-table__cell-right"
                            onClick={event => this.handleClick(event, d)}
                          >
                            {(d.id === null ? 'Pendência: falta salvar no servidor' : util.formatDateHoraToString(d.updatedAt, "")) }
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 49 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
            <TablePagination
              component="div"
              className="material-table__pagination"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{ 'aria-label': 'Previous Page' }}
              nextIconButtonProps={{ 'aria-label': 'Next Page' }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              rowsPerPageOptions={(data.length > 100 ? [10, 25, 50, 100] : (data.length > 50 ? [10, 25, 50] : [10, 25]))}
              dir="ltr"
              SelectProps={{
                inputProps: { 'aria-label': 'rows per pageee' },
                native: true,
              }}
            />
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(MatTable);